// src/buttons/Separator.tsx
import React from "react";
var Separator = class extends React.PureComponent {
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "separator" });
  }
};
export {
  Separator
};
